export default "/048cb1f2b29308e18768c65cfd51e426596a830c/83e791c702f67cc0242109b04d241be7.svg";